import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import TagIcon from '@mui/icons-material/Tag';
import { SvgIconProps } from '@mui/material/SvgIcon';
import { ComponentType } from 'react';

export const serviceIconMap: Record<string, ComponentType<SvgIconProps>> = {
	DeleteOutlined: DeleteOutlinedIcon,
	InfoOutlined: InfoOutlinedIcon,
	Tag: TagIcon,
};
